import React from 'react';
import { useAuth } from './auth';
import { useNavigate, useLocation } from 'react-router-dom';

const MENU = [
    { path: '/',         label: 'Dashboard',  icon: '📊', ready: true },
    { path: '/servers',  label: 'Серверы',    icon: '🖥️', ready: true },
    { path: '/alerts',   label: 'Оповещения', icon: '🔔', ready: true },
    { path: '/terminal', label: 'Терминал',   icon: '💻', ready: true },
    { path: '/settings', label: 'Настройки',  icon: '⚙️', ready: true },
];

export default function Sidebar() {
    const { user, logout } = useAuth();
    const navigate          = useNavigate();
    const location          = useLocation();

    return (
        <aside className="sidebar">
            <div className="sidebar-header">
                <span className="sidebar-logo">🖥️</span>
                <span className="sidebar-title">Monitor</span>
            </div>

            <nav className="sidebar-nav">
                {MENU.map(item => (
                    <button
                        key={item.path}
                        className={[
                            'nav-item',
                            location.pathname === item.path ? 'active' : '',
                            !item.ready ? 'disabled' : '',
                        ].filter(Boolean).join(' ')}
                        onClick={() => item.ready && navigate(item.path)}
                        disabled={!item.ready}
                    >
                        <span className="nav-icon">{item.icon}</span>
                        <span className="nav-label">{item.label}</span>
                        {!item.ready && <span className="nav-badge">скоро</span>}
                    </button>
                ))}
            </nav>

            <div className="sidebar-footer">
                <div className="user-info">
                    <span className="user-avatar">👤</span>
                    <div>
                        <div className="user-name">{user?.username}</div>
                        <div className="user-role">{user?.role}</div>
                    </div>
                </div>
                <button className="btn-logout" onClick={() => { logout(); navigate('/login'); }}>
                    Выйти
                </button>
            </div>
        </aside>
    );
}
